export default "__VITE_ASSET__vx1Bxe3x__"